import React, { useContext, useMemo } from 'react';
import { svgSprite, A } from '../../../hybrid/wrappers';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import { LangContext } from '../../../common/decorators/Language';
import { t } from '../../../common/components/T';
import css from './breadcrumbs.module.scss';
import classNames from 'classnames';

const Breadcrumbs = ({ handleBack, data = {} }) => {
    const { translation } = useContext(LangContext) || {};
    const widthDimensions = useWindowDimensions();
    const isMobile = useMemo(() => (!widthDimensions ? null : widthDimensions < 576), [widthDimensions]);

    if (isMobile) {
        return handleBack ? (
            <>
                {svgSprite('angle-left', {
                    fill: 'var(--greyExtraDarkColor)',
                    width: '4px',
                    height: '8px'
                })}
                <p onClick={handleBack} className={classNames(css.navigationLinks, css.navigationLinksMod)}>
                    {data.title}
                </p>
            </>
        ) : (
            <>
                {svgSprite('angle-left', {
                    fill: 'var(--greyExtraDarkColor)',
                    width: '4px',
                    height: '8px'
                })}
                <A href={`/`} className={classNames(css.navigationLinks, css.navigationLinksMod)}>
                    {t('mainPageTitle', 'Главная', 'all', translation)}
                </A>
            </>
        );
    }
    return (
        <>
            <A href={`/`} className={classNames(css.navigationLinks, css.blueColor)}>
                {t('mainPageTitle', 'Главная', 'all', translation)}
            </A>
            <div
                style={{
                    width: '6px',
                    height: '6px',
                    background: 'rgba(230, 230, 230, 1)',
                    borderRadius: '50%',
                    margin: '0 12px'
                }}
            ></div>
            <A href={`${data.link}`} className={classNames(css.navigationLinks, css.ML10)}>
                {data.title}
            </A>
        </>
    );
};
export default Breadcrumbs;
